/** Permissões exibidas no modal de usuários (UI simplificada). */
export const PERMISSION_UI_DEFS = [
  { id: "dashboard", label: "Dashboard" },
  { id: "estoque", label: "Estoque" },
  { id: "compras", label: "Reposição" },
  { id: "desperdicios", label: "Desperdícios" },
  { id: "financeiro", label: "Financeiro" },
  { id: "fornecedores", label: "Pagamentos" },
  { id: "conferencia", label: "Conferência" },
  { id: "marketing", label: "Marketing" },
  { id: "itens", label: "Itens" },
  { id: "cadastros", label: "Cadastros" },
] as const;

export type PermissionUiId = (typeof PERMISSION_UI_DEFS)[number]["id"];

/** Chaves salvas em allowed_tabs (API) para cada opção da UI. */
const UI_TO_API: Record<PermissionUiId, readonly string[]> = {
  dashboard: ["dashboard"],
  estoque: ["inventario", "entradas"],
  compras: ["compras"],
  desperdicios: ["desperdicios"],
  financeiro: ["financeiro", "vendas", "despesas"],
  fornecedores: ["fornecedores"],
  conferencia: ["conferencia"],
  marketing: ["marketing"],
  itens: ["produtos", "insumos"],
  cadastros: ["parceiros"],
};

/** Chaves adicionadas ao marcar uma opção (sem aliases legados de leitura). */
const UI_TO_API_ON_ENABLE: Record<PermissionUiId, readonly string[]> = {
  dashboard: ["dashboard"],
  estoque: ["inventario", "entradas"],
  compras: ["compras"],
  desperdicios: ["desperdicios"],
  financeiro: ["financeiro"],
  fornecedores: ["fornecedores"],
  conferencia: ["conferencia"],
  marketing: ["marketing"],
  itens: ["produtos", "insumos"],
  cadastros: ["parceiros"],
};

const LEGACY_TAB_LABELS: Record<string, string> = {
  inventario: "Estoque",
  entradas: "Estoque",
  produtos: "Itens",
  insumos: "Itens",
  parceiros: "Cadastros",
  vendas: "Financeiro",
  despesas: "Financeiro",
};

export function isUiPermissionChecked(apiTabs: string[], uiId: PermissionUiId): boolean {
  return UI_TO_API[uiId].some((key) => apiTabs.includes(key));
}

export function toggleUiPermissionInTabs(apiTabs: string[], uiId: PermissionUiId): string[] {
  const relatedKeys = UI_TO_API[uiId];
  const isChecked = relatedKeys.some((key) => apiTabs.includes(key));
  if (isChecked) {
    return apiTabs.filter((tab) => !relatedKeys.includes(tab));
  }
  return [...new Set([...apiTabs, ...UI_TO_API_ON_ENABLE[uiId]])];
}

export function allowedTabsToDisplayLabels(tabs: string[]): string[] {
  const labels: string[] = [];
  const consumed = new Set<string>();

  for (const def of PERMISSION_UI_DEFS) {
    if (isUiPermissionChecked(tabs, def.id)) {
      labels.push(def.label);
      UI_TO_API[def.id].forEach((key) => consumed.add(key));
    }
  }

  for (const tab of tabs) {
    if (consumed.has(tab)) continue;
    labels.push(LEGACY_TAB_LABELS[tab] ?? tab);
  }

  return labels;
}
